import { useCallback, useEffect, useState } from "react";
import { lastMinuteService } from "../../services/lastMinuteService";

// My Listings data + one-click lifecycle actions (extend/renew/unpublish). Mirrors
// the scout-request hook shape. `scope` = "mine" | "agency" (AgencyAdmin filter,
// Invariant 12). Refetches on scope change.
export const useMyListings = (scope = "mine") => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(
    async (signal) => {
      setLoading(true);
      const params = {};
      if (scope === "agency") params.scope = "agency";
      const res = await lastMinuteService.getMyListings(params, signal);
      if (res.success) {
        setListings(res.data);
        setError(null);
      } else {
        setError(res.error);
      }
      setLoading(false);
    },
    [scope],
  );

  useEffect(() => {
    const controller = new AbortController();
    fetch(controller.signal).catch(() => {});
    return () => controller.abort();
  }, [fetch]);

  // Replace one listing in place after an action returns the fresh row.
  const patchLocal = (updated) =>
    setListings((prev) => prev.map((l) => (l.id === updated.id ? updated : l)));

  const extend = async (id) => {
    const res = await lastMinuteService.extend(id);
    if (res.success) patchLocal(res.data);
    return res;
  };
  const renew = async (id) => {
    const res = await lastMinuteService.renew(id);
    if (res.success) patchLocal(res.data);
    return res;
  };
  const unpublish = async (id) => {
    const res = await lastMinuteService.unpublish(id);
    if (res.success) patchLocal(res.data);
    return res;
  };

  return { listings, loading, error, refetch: fetch, extend, renew, unpublish };
};

export default useMyListings;
